import React, { Component } from 'react';
// import { Input } from 'semantic-ui-react'
import Select from 'react-select';
import {connect} from 'react-redux';
 import {host} from '../../../config/config'


class DepartmentNameSearch extends Component {

  constructor(props){
    super(props)
    this.fetcher=this.fetcher.bind(this)
    this.state  = {
      isFetching:true,
      customers_list:''
    }
  }



fetcher(request, mode){
  fetch('http://devb240.tula.ru:8080/api/ocnitcustomerinfo/',

      {
    method: 'POST',
    headers: new Headers({
             'Content-Type': 'application/x-www-form-urlencoded',

    }),

    body: request

      }    )
      .then((response)=>response.json())

        .then((answerpost)=>{

          if(answerpost[0]['text']){this.setState({accessdeny:"Доступ запрещен"})}
           else{this.props.updatecustomers_list(answerpost)}
                    // this.setState({customers_list:answerpost})

        })
}


componentDidMount(){

  const request = "author="+this.props.auth[1]+"&section=customers_list&com=customers_list"
  this.fetcher(request, 'customers_list')

}

handleChange = (selectedOption) => {
    // this.setState({ selectedOption });
    // console.log(`Option selected:`, selectedOption.value);
    this.props.callback(selectedOption.value)
    this.setState({selectedOption:''})
  }
//
// selectedCustomer(cname){
//     console.log('cname'+JSON.stringify(cname, null, 4));
// }

  render() {
    const { selectedOption, customers_list } = this.state;
    const {auth, customers} = this.props
    return (
      <div className='depnamesearch'>

            {auth ?
              <div>
                <Select
                  value={selectedOption}
                  onChange={this.handleChange}
                  options={customers.map(suggestion => ({value: suggestion,label: suggestion}))}
                  styles={{'width':'120px'}}
                  placeholder='Выберите наименивание подразделения'
                />

              </div>
              :
               'asdadsasd'
             }
      </div>
    );
  }

}
export default connect(
  state => ({
    customers:state.customers_list,

  }),
  dispatch => ({
    updatecustomers_list: (customers) => {
      dispatch({ type: 'LOAD_CUSTOMERS', customers: customers })
    },

  })

)(DepartmentNameSearch);
